import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
  categoryName?: string;
  totalRecords?: number;
}

const initialState: InitialState = {};

const getListEmployeeArriveLateRequestSlice = createSlice({
  name: "getListEmployeeArriveLateRequest",
  initialState,
  reducers: {
    getListEmployeeArriveLateRequestStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListEmployeeArriveLateRequestSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
    },
    getListEmployeeArriveLateRequestFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
      state.totalRecords = 0;
    },
    resetListEmployeeArriveLateRequest: (state) => initialState,
  },
});

export const {
  getListEmployeeArriveLateRequestStart,
  getListEmployeeArriveLateRequestSuccess,
  getListEmployeeArriveLateRequestFailed,
  resetListEmployeeArriveLateRequest,
} = getListEmployeeArriveLateRequestSlice.actions;

export default getListEmployeeArriveLateRequestSlice.reducer;
